import { FC, PropsWithChildren } from 'react'

export const BlockedUserInfoGroup: FC<PropsWithChildren<{ title: string }>> = ({
  title,
  children
}) => {
  return (
    <div>
      <p className="text-xs text-slate-500">{title}</p>
      {children}
    </div>
  )
}
